import { createFileRoute, redirect } from "@tanstack/react-router"

/**
 * The standalone AI-matcher setup form is retired. The matcher is now
 * launched as a dialog from the per-game backlog (sparkle icon on each
 * expansion row). Opening this URL directly without a runId redirects to
 * the games dashboard so the admin can pick a game and find the expansion.
 *
 * `/catalogue/ai-matcher/$runId` (the results view) is unaffected.
 */
export const Route = createFileRoute("/catalogue/ai-matcher/")({
	beforeLoad: () => {
		throw redirect({ to: "/games" })
	},
})
